// Email Verification API Module
// Handles email verification operations

import api from "../axios";
import { handleApiResponse } from "../handleApiResponse";

export const verifyEmail = (token: string) =>
  handleApiResponse(api.post("/v1/auth/verify-email", { token }));

export const resendVerificationEmail = (email: string) =>
  handleApiResponse(api.post("/v1/auth/resend-verification", { email }));
